'use client'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import translationEN from './locales/en'
import translationPT from './locales/pt-BR'

export const defaultLanguage = 'pt'

const resources = {
  pt: { common: translationPT },
  en: { common: translationEN },
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['pt', 'en'],
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    debug: false,
    defaultNS: ['common'],
    interpolation: {
      escapeValue: false,
    },
    resources,
  })

export default i18n
